<template>
  <!-- int、float、double -->
  <el-form-item
    :label="item.name"
    :prop="item.identifier"
    v-if="isNumberType(item.dataType)"
    :rules="[
      {
        validator: (rule, value, callback) => validateNumber(item, value, callback),
        trigger: 'blur'
      }
    ]"
  >
    <el-input v-model="form[item.identifier]"></el-input>
    <span class="tip">取值范围：{{ item.specs.min }}-{{ item.specs.max }}</span>
  </el-form-item>
  <!-- text -->
  <el-form-item
    :label="item.name"
    :prop="item.identifier"
    v-else-if="isTextType(item.dataType)"
    :rules="[
      {
        validator: (rule, value, callback) => validateText(item.specs.length, value, callback),
        trigger: 'blur'
      }
    ]"
  >
    <el-input v-model="form[item.identifier]"></el-input>
    <span class="tip">字节限制：{{ item.specs.length }}</span>
  </el-form-item>
  <!-- bool 、 enum-->
  <el-form-item :label="item.name" :prop="item.identifier" v-else-if="isEnumType(item.dataType)">
    <el-radio-group v-model="form[item.identifier]">
      <el-radio v-for="(value, key) in item.specs.enumDesc" :key="key" :label="key">
        {{ value }}
      </el-radio>
    </el-radio-group>
  </el-form-item>
  <!-- array -->
  <div v-else-if="isArrayType(item.dataType)">
    <el-form-item :label="item.name" :prop="item.identifier">
      <template v-if="form[item.identifier] && form[item.identifier].length > 0">
        <template v-for="(arrItem, arrayIndex) in form[item.identifier]">
          <el-form-item
            v-if="
              item.specs.type === 'int' ||
                item.specs.type === 'float' ||
                item.specs.type === 'double'
            "
            :prop="`${item.identifier}[${arrayIndex}]`"
            :key="arrayIndex"
            :rules="[
              {
                validator: (rule, value, callback) =>
                  validateNumber({ ...arrItem, dataType: item.specs.type }, value, callback, true),
                trigger: 'blur'
              }
            ]"
          >
            <el-input v-model="form[item.identifier][arrayIndex]"></el-input>
            <hl-button
              type="text"
              style="margin-left: 10px;"
              @click="handleArrItemRemove(form[item.identifier], arrayIndex)"
              >{{ this.$t('Common.del') }}</hl-button
            >
          </el-form-item>
          <el-form-item
            v-if="item.specs.type === 'text'"
            :prop="`${item.identifier}[${arrayIndex}]`"
            :key="arrayIndex"
          >
            <el-input v-model="form[item.identifier][arrayIndex]"></el-input>
            <hl-button
              type="text"
              style="margin-left: 10px;"
              @click="handleArrItemRemove(form[item.identifier], arrayIndex)"
              >{{ this.$t('Common.del') }}</hl-button
            >
          </el-form-item>
        </template>
      </template>
      <div
        v-if="form[item.identifier].length < item.specs.length"
        class="add-array-item__button"
        @click="handleArrItemAdd(form[item.identifier])"
      >
        添加
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { intergerReg, numberReg } from '@/utils/regex'
export default {
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: Object,
    item: Object
  },
  methods: {
    isNumberType(dataType) {
      return ['int', 'float', 'double'].indexOf(dataType) > -1
    },
    isTextType(dataType) {
      return ['text'].indexOf(dataType) > -1
    },
    isArrayType(dataType) {
      return ['array'].indexOf(dataType) > -1
    },
    isEnumType(dataType) {
      return ['enum', 'bool'].indexOf(dataType) > -1
    },
    // 获取字符串字节长度
    getByteLen(str) {
      if (typeof str === 'string') {
        let len = 0
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) < 0 || str.charCodeAt(i) > 255) {
            len += 2
          } else {
            len += 1
          }
        }
        return len
      }
      return 0
    },
    validateText(length, value, callback) {
      if (value !== '' && (value != null) & (this.getByteLen(value) > length)) {
        callback(new Error(`字节长度不能超过${length}`))
      } else {
        callback()
      }
    },
    validateNumber(item, value, callback, noValiateRange) {
      // value = Number(value)
      const { dataType } = item
      let min = null
      let max = null
      if (item.specs) {
        min = item.specs.min
        max = item.specs.max
      }
      if (value == null || value === '') {
        callback()
      } else {
        if (dataType === 'int' && !intergerReg.test(value)) {
          return callback(new Error('请输入正确的整数'))
        }
        if (dataType !== 'int' && !numberReg.test(value)) {
          return callback(new Error('请输入正确的整数'))
        }
        if (!noValiateRange) {
          if (value < min || value > max) {
            return callback(new Error(`取值范围：${min} - ${max}`))
          }
        }
        callback()
      }
    },
    handleArrItemRemove(arr, index) {
      arr.splice(index)
    },
    handleArrItemAdd(arr) {
      if (!arr) {
        arr = []
      }
      arr.push(undefined)
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  margin-left: 10px;
}
.add-array-item__button {
  width: 280px;
  line-height: 1;
  text-align: center;
  padding: 6px 0;
  border: 2px dashed #dadfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #339dff;
  cursor: pointer;
}
</style>
